import React from "react";

const AssignmentStatus = (props) => {
    switch (props.status) {
      case "Open":
        return (
          <>
          <div className="assessment-03">
            <span className="as-blue-bg  as-widget">Open</span>
          </div>
          </>
        );
        break;
      case "Draft":
        return (
          <>
            <div className="assessment-03">
              <span className="as-green-bg as-widget">Draft</span>
            </div>
          </>
        );
        break;
      case "Submitted":
        return (
          <>
            <div className="assessment-03">
              <span className="as-green-bg as-widget">Submitted</span>
            </div>
          </>
        );
        break;
      case "Closed-Submitted":
        return (
          <>
            <div className="assessment-03">
              <span className="as-orange-bg as-widget">Closed-Submitted</span>
            </div>
          </>
        );
        break;

      case "Pending":
        return (
          <>
            <div className="assessment-03">
              <span className="as-orange-bg as-widget">Pending</span>
            </div>
          </>
        );
        break;
      case "Closed-Marked":
        return (
          <>
          <div className="assessment-03">
            <span className="as-blue-bg as-widget">Closed-Marked</span>
          </div>
          </>
        );
        break;
      case "Closed Not-Submitted":
        return (
          <>
          <div className="assessment-03">
            <span className="as-red-bg as-widget">Closed Not-Submitted</span>
          </div>
          </>
        );
        break;
      default:
        return (
          <>
            <div className="assessment-03">
              <span className="as-red-bg as-widget">Unknown Status</span>
            </div>
          </>
        );
        break;
    }
}
export default AssignmentStatus;
